export function Leaf({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" fill="currentColor" className={className} aria-hidden="true">
      <path d="M20.5 3.5C11 4 4.5 9.5 4.5 18.5c0 .6.1 1.3.2 2 .6.1 1.2.2 1.8.2 9 0 13.5-7.5 14-17.2zM6 20c1.5-5.5 5-9.5 10.5-12-4.5 3.6-7.8 7.4-9.3 12H6z" />
    </svg>
  );
}

export function FloatingLeaves({ className = "" }) {
  const leaves = [
    { left: "6%", top: "18%", size: "w-6 h-6", delay: "0s", rotate: "rotate-12" },
    { left: "88%", top: "12%", size: "w-8 h-8", delay: "1.4s", rotate: "-rotate-45" },
    { left: "78%", top: "68%", size: "w-5 h-5", delay: "2.6s", rotate: "rotate-90" },
    { left: "14%", top: "74%", size: "w-7 h-7", delay: "0.8s", rotate: "rotate-45" },
  ];
  return (
    <div className={`pointer-events-none absolute inset-0 overflow-hidden ${className}`} aria-hidden="true">
      {leaves.map((l, i) => (
        <div
          key={i}
          className={`absolute ${l.size} ${l.rotate} ${i > 1 ? "hidden sm:block" : ""} text-goldlight/50 animate-float-leaf`}
          style={{ left: l.left, top: l.top, animationDelay: l.delay }}
        >
          <Leaf className="w-full h-full" />
        </div>
      ))}
    </div>
  );
}

const MARQUEE_ITEMS = [
  "Pure From Our Farm to Your Home",
  "Naturally Grown",
  "Carefully Nurtured",
  "Truly Organic",
  "Farm Fresh",
  "Grown With Nature",
];

export function Marquee({ dark = true }) {
  const row = (
    <>
      {MARQUEE_ITEMS.map((item, i) => (
        <span key={i} className="inline-flex items-center shrink-0">
          <span
            className={`font-serif italic text-2xl sm:text-3xl lg:text-4xl px-8 sm:px-12 whitespace-nowrap ${
              dark ? "text-cream/80" : "text-forest/80"
            }`}
          >
            {item}
          </span>
          <Leaf className={`w-5 h-5 shrink-0 ${dark ? "text-gold" : "text-gold"}`} />
        </span>
      ))}
    </>
  );
  return (
    <div
      data-testid="editorial-marquee"
      className={`relative overflow-hidden py-8 sm:py-10 border-y ${
        dark ? "bg-nightgreen border-gold/10" : "bg-beige border-sand"
      }`}
    >
      <div className="flex w-max animate-marquee">
        <div className="flex items-center">{row}</div>
        <div className="flex items-center" aria-hidden="true">{row}</div>
      </div>
    </div>
  );
}

export function Grain() {
  return <div className="grain-overlay" aria-hidden="true" />;
}
